// extracted by mini-css-extract-plugin
module.exports = {"frequently-asked-questions":"categoryFAQs_frequently-asked-questions__KISmC"};